"use client";
const e = Object.freeze({
  bold: "700",
  normal: "400"
}), t = Object.keys(e);
export {
  e as FONT_WEIGHTS,
  t as FONT_WEIGHT_KEYS
};
